import { render } from "./Shop.vue?vue&type=template&id=85691038&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=85691038&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85691038"]])

export default __exports__